import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  Renderer2,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationExtras,
  Router,
} from '@angular/router';
import { filter, first } from 'rxjs';
import { BaniSubSectionDetailTypes } from 'src/app/core/constants';
import { BaniSectionProps } from 'src/app/core/enum';
import { AllBaniData, BaniSection, BaniSubSection } from 'src/app/core/models';
import { DashboardService } from 'src/app/services/dashboard.service';
import { UtilsService } from 'src/app/services/utils.service';
import { StorageService } from 'src/app/services/storage.service';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-bani-sub-details',
  templateUrl: './bani-sub-details.component.html',
  styleUrls: ['./bani-sub-details.component.scss'],
})
export class BaniSubDetailsComponent implements OnInit {
  isHandsetPortrait: boolean = false;
  initHandler: boolean = false;
  isBaniSubDetailsLoading: boolean = false;
  isBaniSubDetailsData: AllBaniData[] = [];
  activeSectionId: number = 0;
  activeSectionSequence: any = null;
  activeSubSectionSequence: string | null = null;
  activeSectionData: BaniSection = {} as BaniSection;
  activeSubSectionData: BaniSubSection = {} as BaniSubSection;
  activeSubSectionContent: string = '';
  activeSubSectionHTML: SafeHtml = '';
  baniSubsectionDetailTypes: any;
  activeSubsectionDetailTitle: string = 'Overview';
  sectionName: string = '';
  sectionBannerImage: any = '';
  subSectionName: string = '';
  heirarchyCommonData: any = {};
  subSectionLength: any = '';
  sectionsList: any = [];
  allFootnotes: any = [];
  baniCode: string | null = '';
  subSectionTopContent: SafeHtml = '';
  xPosition: number = 0;
  yPosition: number = 0;
  tooltipText: string = '';
  isVisible: boolean = false;
  isDictionaryTooltipVisible: boolean = false;
  wordDictionaryDetails: any = null;
  visible: boolean = false;
  isVisibleShare: boolean = false;
  fontSize: any = 16;
  txtColor: any = '';
  bakUrl: any = '';
  shareUrl: string | null = '';
  searchText: any = '';
  paramObj:any='';
  prevButtonText: string = '';
  nextButtonText: string = '';
  allNavigationButtonsList: any[] = [];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dashboardService: DashboardService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private storage: StorageService,
    private utils: UtilsService,
    @Inject(DOCUMENT) private document: Document
  ) {
    route.params.subscribe((val) => {
      this.initDataSetSequence();
    });
    // this.metaService.updateTag({ name: 'description', content: 'changing   tags' });
    let currentLanguage = localStorage.getItem('language');
    if (currentLanguage) {
      this.baniSubsectionDetailTypes =
        currentLanguage === 'en'
          ? BaniSubSectionDetailTypes.en
          : BaniSubSectionDetailTypes.pa;
    }

    let currentFontSize = localStorage.getItem('fontSize');
    //console.log(currentFontSize);
    if (currentFontSize) {
      this.fontSize = +currentFontSize;
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const changedUrl = event.url;
        this.shareUrl = location.origin + changedUrl;
        // console.log('Changed URL:', this.shareUrl);
      });
  }

  ngOnInit(): void {
    const firstParam: any = this.route.snapshot.queryParamMap?.get('txt');
    const xParam: any = this.route.snapshot.queryParamMap?.get('x');
    const yParam: any = this.route.snapshot.queryParamMap?.get('y');
    const langParam: any = this.route.snapshot.queryParamMap?.get('lang');
    this.searchText=firstParam;
    this.paramObj= {
      searchText: firstParam,
      x: xParam,
      y: yParam,
      lang: langParam
    };
    if(this.searchText == null){
      const subSectionSequenceParam = this.route.snapshot.paramMap.get('subSectionSequence');      
      this.getBaniDetailUrlTxtValue(subSectionSequenceParam);      
    }

    this.shareUrl = location.origin + this.router.url;
    if (
      this.baniSubsectionDetailTypes &&
      this.baniSubsectionDetailTypes.length > 0
    ) {
      const firstType = this.baniSubsectionDetailTypes[0];
      this.activeAccordionItems.add(firstType);
      this.handleSubSectionTypeSelect(firstType);
    }
    // this.metaService.updateTag({ property: 'og:url', content:  location.origin + this.router.url});
    // this.metaService.updateTag({ property: 'og:title', content: this.heirarchyCommonData?.BaniName });
    // this.metaService.updateTag({ property:'og:image', content:"https://devtggspstorage.blob.core.windows.net/sikhriimages/Barahmaha/SectionImg/Barah Maha_DashboardWebBanner_1440x250.webp" });
    // this.metaService.updateTag({ property:'og:description', content: 'Test' });
    // this.initDataSetSequence();
  }

  getBaniDetailUrlTxtValue(subSectionSequenceParam: any) {
    if (subSectionSequenceParam) {
      let decodedParam = subSectionSequenceParam;
      while (decodedParam !== decodeURIComponent(decodedParam)) {
        decodedParam = decodeURIComponent(decodedParam);
      }
      const match = decodedParam
        ? decodedParam.match(/(\d+)\?(.+)=(.+)/)
        : null;
      if (match) {
        const value = match[3];
        this.searchText = value;
      }
    }
  }

 removeAllOtherTooltips() {
  const elements = this.elementRef.nativeElement.querySelectorAll('.tooltiptext');
  elements.forEach((el: HTMLElement) => {
    this.renderer.removeClass(el, 'is-visible');
    this.renderer.removeStyle(el, 'left');
    this.renderer.removeStyle(el, 'right');
    this.renderer.removeStyle(el, 'top');
    this.renderer.removeStyle(el, 'bottom');

    this.renderer.removeStyle(el, 'opacity');
    this.renderer.removeStyle(el, 'visibility');
  });
}


@HostListener('document:click', ['$event'])
onClick(event: MouseEvent) {
  const target = event.target as HTMLElement;

  if (target.classList.contains('show-footnote-icon')) {

    const parent = target.parentElement;
    const tooltip = parent?.querySelector('.tooltiptext') as HTMLElement;
    if (!tooltip) return;

    this.removeAllOtherTooltips();

    // Prepare to measure
    this.renderer.addClass(tooltip, "is-visible");
    this.renderer.setStyle(tooltip, "opacity", "0");
    this.renderer.setStyle(tooltip, "visibility", "hidden");

    setTimeout(() => {
      const iconRect = target.getBoundingClientRect();
      const tipRect = tooltip.getBoundingClientRect();

      const screenWidth = Math.min(window.innerWidth, 1280);
      const screenLeft = (window.innerWidth - screenWidth) / 2;
      const screenRight = screenLeft + screenWidth;

      /** RESET */
      this.renderer.removeStyle(tooltip, "top");
      this.renderer.removeStyle(tooltip, "left");

      /* -----------------------------------
         HORIZONTAL POSITION (FIXED)
      ----------------------------------- */

      let left = iconRect.left;

      // Ensure tooltip stays inside the 1280px main view
      if (left + tipRect.width > screenRight) {
        left = screenRight - tipRect.width - 10;
      }
      if (left < screenLeft) {
        left = screenLeft + 10;
      }

      /* -----------------------------------
         VERTICAL POSITION (FIXED)
      ----------------------------------- */

      let top = iconRect.bottom + 10;

      if (top + tipRect.height > window.innerHeight) {
        // show above
        top = iconRect.top - tipRect.height - 10;
      }

      // If still doesn't fit → center vertically
      if (top < 0 || top + tipRect.height > window.innerHeight) {
        top = (window.innerHeight - tipRect.height) / 2;
      }

      // Apply
      // this.renderer.setStyle(tooltip, "left", `${ screenWidth < 600 ? (screenWidth - left) + 25 : left }px`);
      this.renderer.setStyle(tooltip, "left", `${ screenWidth < 599.98 ? 60 : left }px`);
      this.renderer.setStyle(tooltip, "top", `${top}px`);

      // Show tooltip
      this.renderer.setStyle(tooltip, "opacity", "1");
      this.renderer.setStyle(tooltip, "visibility", "visible");

    }, 15);

    return;
  }

  // If clicked inside tooltip → DO NOT CLOSE
  if (target.closest(".tooltiptext")) return;

  this.removeAllOtherTooltips();
}

  /**
   * request to fetch footnotes by baniId and sectionId
   * section will always be 0 on the Introduction page
   * @param section number = 0
   */
  fetchBaniFootnotes(section: number = 0) {
    this.dashboardService
      .fetchBaniFootnotes(this.heirarchyCommonData.BaniId, this.activeSectionId)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          if (res?.value?.length) this.allFootnotes = res.value;

          let currentLanguage = localStorage.getItem('language');

          if (currentLanguage == 'en') {
            this.handleSubSectionTypeSelect(
              Number(this.activeSubSectionSequence) === 1
                ? BaniSectionProps.OVERVIEW
                : BaniSectionProps.COMMENTARY
            ); // this sets data in the template
          } else {
            this.handleSubSectionTypeSelect(
              Number(this.activeSubSectionSequence) === 1
                ? BaniSectionProps.OVERVIEW
                : BaniSectionProps.COMMENTARY
            );
          }

          // this method is now called after this step
          setTimeout(() => {
            this.attachDictionaryHandler();
          }, 200);
        },
        error: () => {
          // console.log('error in fetching bani footnotes');
        },
      });
  }

  fetchWordFromDictionary(word: string, xCords: any, yCords: any) {
 
    //Check if string has dot explode it and get the chracter for search
    var str = word;
    var ans = str.includes('.') ? 'true' : 'false';
    if (ans == 'true') {
      const myArray = str.split('.');
      word = myArray[0];
    }

    //check string has -
    var ans1 = str.includes('-') ? 'true' : 'false';
    if (ans1 == 'true') {
      const replace = str.replace('-', '- ');
      word = replace;
    }

    this.dashboardService
      .fetchWordFromDictionary(word?.trim(), this.baniCode)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
           
          const filteredDictionaryWord = this.filterDictionaryWord(
            res,
            xCords,
            yCords
          );
         
           console.log(filteredDictionaryWord[0])
          this.wordDictionaryDetails = res?.value?.length
            ? filteredDictionaryWord[0]
            : null;
        },
        error: () => {
          // console.log('error in fetching word from dictionary');
        },
      });
  }

  filterByXYCoordinates(res: any, xCords: any, yCords: any) {
    return res.value.filter(
      (item: { X_CoordinatePosition: any; Y_CoordinatePosition: any }) =>
        item.X_CoordinatePosition === xCords &&
        item.Y_CoordinatePosition === yCords
    );
  }

  filterByURLParamsAndXYCoords(
    res: any,
    urlBaniCode: any,
    urlSectionSequence: number,
    urlSubSectionSequence: number
  ): any[] {
    const filteredByXY = this.filterByXYCoordinates(res, null, null); // Reuse XY filter with null values
    return filteredByXY.filter(
      (item: {
        BaniCode: any;
        SectionSequence: number;
        SubSectionSequence: number;
      }) =>
        item.BaniCode === urlBaniCode &&
        item.SectionSequence === urlSectionSequence &&
        item.SubSectionSequence === urlSubSectionSequence
    );
  }

  filterByAllNulls(res: any) {
    return res.value.filter(
      (item: {
        X_CoordinatePosition: null;
        Y_CoordinatePosition: null;
        BaniCode: null;
        SectionSequence: null;
        SubSectionSequence: null;
      }) =>
        item.X_CoordinatePosition === null &&
        item.Y_CoordinatePosition === null &&
        item.BaniCode === null &&
        item.SectionSequence === null &&
        item.SubSectionSequence === null
    );
  }

  filterDictionaryWord(res: any, xCords: any, yCords: any) {
    // 1. When only one value in response
    if (res?.value.length == 1) {
      return res?.value;
    }
    // 2. Try filtering by matching XY coordinates
    const filteredByCoords = this.filterByXYCoordinates(res, xCords, yCords);
    if (filteredByCoords.length > 0) {
      return filteredByCoords;
    }
    // 3. Try filtering by matching URL parameters and null XY coordinates
    const filteredByBaniCodeEtc = this.filterByURLParamsAndXYCoords(
      res,
      this.baniCode,
      +this.activeSectionSequence,
      +(this.activeSubSectionSequence as string)
    );
    if (filteredByBaniCodeEtc.length > 0) {
      return filteredByBaniCodeEtc;
    }
    // 4. If no previous match, filter for all matching null values
    return this.filterByAllNulls(res);
  }

  attachDictionaryHandler() {
    const dictionaryWords =
      this.document.getElementsByClassName('dictionary-word');

    // Convert the HTMLCollection to an array
    const wordsArray = Array.from(dictionaryWords);
    //  console.log(wordsArray)
    // Attach a click event listener to the parent container
    this.elementRef.nativeElement.addEventListener('click', (event: any) => {
      console.log(event.clientX, event.clientY);

      console.log(event.clientX, event.clientY);

      const clickedElement = event.target;

      let pixelsScrolledX = window.scrollX;
      let pixelsScrolledY = window.scrollY;
      // console.log(pixelsScrolledX,pixelsScrolledY)
      // Get the current position of the clicked text
      const position = clickedElement.getBoundingClientRect();
      const popupX = position.left;
      const popupY = position.bottom + pixelsScrolledY + 2; // Adjust the vertical position as needed

      console.log(popupX);
      console.log(popupY);
      let xCords: number = +clickedElement?.getAttribute('x');
      let yCords: number = +clickedElement?.getAttribute('y');

      let wordMatch = wordsArray.filter((wordInfo: any) => {
        return (
          clickedElement.textContent &&
          wordInfo.innerText === clickedElement.textContent
        );
      });
      // console.log(wordMatch.length,wordMatch,clickedElement.textContent)
      if (wordMatch?.length) {
        //window.scrollTo(0, 0);
        const clickedWord = clickedElement.textContent;
        console.log('XCords', xCords, 'YCOrds', yCords);
        //this.renderer.removeClass(event.target, 'className');
        //this.renderer.addClass(event.target, 'className');

        this.fetchWordFromDictionary(clickedWord, xCords, yCords);

        //determine popup X and Y position to ensure it is not clipped by screen borders
        const popupHeight = 400, // hardcode these values
          popupWidth = 200; // or compute them dynamically

        let popupXPosition, popupYPosition;
        if (event.clientX + popupWidth > window.innerWidth) {
          popupXPosition = event.pageX - popupWidth;
        } else {
          popupXPosition = event.pageX - popupWidth;
          //popupXPosition = event.pageX;
        }

        if (event.clientY + popupHeight > window.innerHeight) {
          popupYPosition = event.pageY - popupHeight;
        } else {
          popupYPosition = event.pageY;
        }

        //close popup inside description
        if (xCords >= 0) {
          this.openTooltip(
            popupX > window.innerWidth - popupWidth ? popupXPosition : popupX,
            popupY
          );
        }
        //this.openTooltip(popupX, popupY);
        // this.openTooltip(event.clientX, event.clientY);
      } else {
        this.isDictionaryTooltipVisible = false;
      }
    });
  }

  openTooltip(x: number, y: number) {
    // Set the position and content of the tooltip component
    window.innerWidth < 599.98 ? this.xPosition = 15 : this.xPosition = x;
    this.yPosition = y;

    // Show the tooltip component
    this.isDictionaryTooltipVisible = true;
  }

  initDataSetSequence() {
    let baniCode = (this.baniCode =
      this.route.snapshot.paramMap.get('baniCode'));
    this.activeSectionSequence =
      this.route.snapshot.paramMap.get('sectionSequence');
    // this.activeSubSectionSequence =
    //   this.route.snapshot.paramMap.get('subSectionSequence');

    const subSectionSequenceParam: string | null =
      this.route.snapshot.paramMap.get('subSectionSequence');
    let subSectionSequenceNumber: string | null = null;
    if (subSectionSequenceParam) {
      const decodedParam = decodeURIComponent(
        decodeURIComponent(subSectionSequenceParam)
      );
      // Extract the number part
      const matches = decodedParam.match(/^(\d+)/);
      if (matches) {
        subSectionSequenceNumber = parseInt(matches[1], 10).toString();
      }
    }
    this.activeSubSectionSequence = subSectionSequenceNumber;

    this.isBaniSubDetailsLoading = true;
    this.dashboardService
      .fetchBaniSubDetails(
        baniCode,
        Number(this.activeSectionSequence),
        Number(this.activeSubSectionSequence)
      )
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.isBaniSubDetailsLoading = false;
          this.isBaniSubDetailsData = res?.value.length ? res?.value : [];

          this.heirarchyCommonData = this.isBaniSubDetailsData[0];
          this.sectionsList = this.heirarchyCommonData.Sections;

          // sort sections in descreasing increasing order by SectionSequence
          this.sectionsList = this.sectionsList.sort(
            (a: any, b: any) =>
              parseFloat(a.SectionSequence) - parseFloat(b.SectionSequence)
          );
          this.setActiveSectionId();

          this.setSectionName(Number(this.activeSectionSequence));
          this.setSubSectionName(
            Number(this.activeSectionSequence),
            Number(this.activeSubSectionSequence)
          );

          this.fetchBaniFootnotes();
// ------------------------------------------------------------------------------------------------------------
          // Fetch navigation buttons data
          let data = res?.value?.length ? res.value[0] : null;
          if (!data) return;
          this.allNavigationButtonsList = [];
          this.allNavigationButtonsList.push({
            type: 'introDetail',
            RowID: data.RowID,
            BaniCode: data.BaniCode,
            BaniId: data.BaniId,
            BaniSequence: data.BaniSequence,
            BaniName: data.BaniName,

            Introduction: !!data.Introduction,
            HistoricalDimension: !!data.HistoricalDimension,
            MusicalDimension: !!data.MusicalDimension,
            CulturalDimension: !!data.CulturalDimension,
            SignificantTerms: !!data.SignificantTerms,

            NavBaniName: data.NavBaniName,
            IsIntroduction: data.IsIntroduction,
            /* Sections: data?.Sections?.map((Section: any) => ({
              type: 'section',
              SectionId: Section.SectionId,
              SectionName: Section.SectionName,
              SectionSequence: Section.SectionSequence,
              NavSectionName: Section.NavSectionName,
              PageNumberStart: Section.PageNumberStart,

              SubSection: Section?.SubSection?.map((sub: any) => ({
                type: 'subsection',
                SubSectionId: sub.SubSectionId,
                SubSectionName: sub.SubSectionName,
                SectionName: sub.SectionName,
                SubSectionSequence: sub.SubSectionSequence
              })) || []
            })) || [] */
          });
// ------------------------------------------------------------------------------------------------------------
        },
        error: (err: any) => {},
      });
  }

  setFootnotesData(htmlString: any) {
    let paragraph: any = htmlString?.slice();
    let modifiedHTML = htmlString?.slice();

    //modifiedHTML = modifiedHTML.replace(/\n/g, '<br>');
    //modifiedHTML = modifiedHTML.replace(/\r\n\r/g, '\r\r');
    modifiedHTML = modifiedHTML?.replace(/\r/g, '<br>');

    // Extracting values and creating an array of objects
    var tagRegex =
      /<bani:\s*(.*?)\s*&\s*section:\s*(.*?)\s*&\s*footnote:\s*(.*?)>/g;

    var match;

    while ((match = tagRegex.exec(paragraph)) !== null) {
      var bani = match[1];
      var section = match[2];
      var footnote = match[3];
      let tooltipTextData: any = this.allFootnotes?.find((footnoteData: any) => {
        return footnoteData.FootNoteId == +footnote;
      });
      modifiedHTML = modifiedHTML?.replace(
        `<bani:${bani} & section:${section} & footnote:${footnote}>`,
        `<div class="tooltip1">  <img alt="Bani footnote" bani="${bani}" section="${section}" footnote="${footnote}" class=\'show-footnote-icon\' src=\'/assets/images/edit-icon-16.png\' >
        <span class="tooltiptext"> ${
          tooltipTextData?.FootNoteContent
            ? tooltipTextData?.FootNoteContent
            : ''
        } </span>
      </div> `
      );
    }

    return this.sanitizer.bypassSecurityTrustHtml(modifiedHTML);
  }
  navigateOnIntroductionPage(pageType: string) {
    const firstBaniId = this.allNavigationButtonsList[0]?.BaniId;
    if (!firstBaniId) {
      console.warn('No baniId found for navigation');
      return;
    }
    this.router.navigate(['/bani', 'introduction', firstBaniId, pageType]);
  }

  isElementInLeftHalf(element: any): boolean {
    const { left, width } = element.getBoundingClientRect();
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    return [left, left + width][1] < viewportWidth / 2;
  }

  isValidOverview(value: any): boolean {
    return value && !/^[\r\n\s]*$/.test(value) && value != '<b>N/A</b>';
  }
  showModifiedOverview(html: any) {
    return html;
  }

  showFotNotTextHTML(html: any) {
    return html;
  }

  setActiveSectionId() {
    const sectionData = this.sectionsList?.find((sectionData: any) => {
      return sectionData.SectionSequence === Number(this.activeSectionSequence);
    });

    this.activeSectionId = sectionData.SectionId;
  }

  goToBaniDashboard() {
    this.router.navigate(['bani', this.baniCode]);
  }
  activeAccordionItems: Set<string> = new Set();
  subSectionContentMap: { [key: string]: SafeHtml | string } = {};

  toggleAccordion(type: string) {
    if (this.activeAccordionItems.has(type)) {
      this.activeAccordionItems.delete(type);
      delete this.subSectionContentMap[type];
    } else {
      this.activeAccordionItems.add(type);
      this.handleSubSectionTypeSelect(type);
    }
  }
  htmlContent: any = '';
  handleSubSectionTypeSelect(type: string) {
    let baniSubsectionDetailType = type;

    if (
      baniSubsectionDetailType === 'Commentary' &&
      !this.activeSubSectionData.SubSectionCommentary
    ) {
      baniSubsectionDetailType = 'Literal Translation';
    }

    let displayTitle = baniSubsectionDetailType;
    this.activeSubsectionDetailTitle = displayTitle;

    let currentLanguage = localStorage.getItem('language');
    if (currentLanguage == 'pa') {
      if (baniSubsectionDetailType === 'Literal Translation')
        displayTitle = 'ਸ਼ਾਬਦਕ ਅਨੁਵਾਦ';
      else if (baniSubsectionDetailType === 'Commentary')
        displayTitle = 'ਵਿਆਖਿਆ';

      if (baniSubsectionDetailType === 'ਵਿਆਖਿਆ') {
        baniSubsectionDetailType = 'Commentary';
        displayTitle = 'ਵਿਆਖਿਆ';
      }
      if (baniSubsectionDetailType == 'ਸ਼ਾਬਦਕ ਅਨੁਵਾਦ') {
        baniSubsectionDetailType = 'Literal Translation';
        displayTitle = 'ਸ਼ਾਬਦਕ ਅਨੁਵਾਦ';
      }
      if (baniSubsectionDetailType == 'ਕਾਵਿਕ ਪਖ') {
        baniSubsectionDetailType = 'Poetical Dimension';
        displayTitle = 'ਕਾਵਿਕ ਪਖ';
      }
      if (baniSubsectionDetailType == 'ਭਾਵਾਰਥਕ-ਸਿਰਜਣਾਤਮਕ ਅਨੁਵਾਦ') {
        baniSubsectionDetailType = 'Interpretive Transcreation';
        displayTitle = 'ਭਾਵਾਰਥਕ-ਸਿਰਜਣਾਤਮਕ ਅਨੁਵਾਦ';
      }
      if (baniSubsectionDetailType == 'ਕੈਲੀਗ੍ਰਾਫੀ') {
        baniSubsectionDetailType = 'Calligraphy';
        displayTitle = 'ਕੈਲੀਗ੍ਰਾਫੀ';
      }
    }

    // Determine HTML content based on type, as before
    switch (baniSubsectionDetailType) {
      case BaniSectionProps.OVERVIEW:
        this.htmlContent = this.setFootnotesData(
          this.activeSubSectionData.SubSectionContent
        );
        break;
      case BaniSectionProps.COMMENTARY:
        this.htmlContent = this.setFootnotesData(
          this.activeSubSectionData.SubSectionCommentary
        );
        break;
      case BaniSectionProps.LITERAL_TRANSLATION:
        this.htmlContent = this.setFootnotesData(
          this.activeSubSectionData.SubSectionLiteralTranslation
        );
        break;
      case BaniSectionProps.POETIC_DIMENSION:
        this.htmlContent = this.setFootnotesData(
          this.activeSubSectionData.SubSectionPoeticalDimension
        );
        break;
      case BaniSectionProps.INTERPRETIVE:
        this.htmlContent = this.setFootnotesData(
          this.activeSubSectionData.SubSectionMeaningInterpretive
        );
        break;
      case BaniSectionProps.CALLIGRAPHY:
        if (this.activeSubSectionData.CalligraphyImageURL != '') {
          this.htmlContent = `<img alt='Calligraphy' class='caligraphy-image' src="${this.activeSubSectionData.CalligraphyImageURL}">`;
        }
        break;
    }

    this.subSectionContentMap[type] = this.htmlContent;
    this.subSectionTopContent = this.addCustomSpacesAndBreaksInString(
      this.activeSubSectionData.SubSectionContent
    );
  }
  /* 
  handleSubSectionTypeSelect(baniSubsectionDetailType: string) {
    if(baniSubsectionDetailType === 'Commentary'  && !this.activeSubSectionData.SubSectionCommentary){
        baniSubsectionDetailType = 'Literal Translation'

    }
    this.activeSubsectionDetailTitle = baniSubsectionDetailType;
    

      let currentLanguage = localStorage.getItem('language');
     
      if(currentLanguage == 'pa'){   
      if(baniSubsectionDetailType === 'Literal Translation')
      this.activeSubsectionDetailTitle = 'ਸ਼ਾਬਦਕ ਅਨੁਵਾਦ';
    else if(baniSubsectionDetailType === 'Commentary')
      this.activeSubsectionDetailTitle = 'ਵਿਆਖਿਆ';

       if(baniSubsectionDetailType === 'ਵਿਆਖਿਆ'){
        baniSubsectionDetailType = 'Commentary';
        this.activeSubsectionDetailTitle = 'ਵਿਆਖਿਆ';
       }
        
        if(baniSubsectionDetailType == 'ਸ਼ਾਬਦਕ ਅਨੁਵਾਦ'){
          baniSubsectionDetailType = 'Literal Translation';
          this.activeSubsectionDetailTitle = 'ਸ਼ਾਬਦਕ ਅਨੁਵਾਦ';
        }
        if(baniSubsectionDetailType == 'ਕਾਵਿਕ ਪਖ'){
          baniSubsectionDetailType = 'Poetical Dimension';
          this.activeSubsectionDetailTitle = 'ਕਾਵਿਕ ਪਖ';
        }
        if(baniSubsectionDetailType == 'ਭਾਵਾਰਥਕ-ਸਿਰਜਣਾਤਮਕ ਅਨੁਵਾਦ'){
          baniSubsectionDetailType = 'Interpretive Transcreation';
          this.activeSubsectionDetailTitle = 'ਭਾਵਾਰਥਕ-ਸਿਰਜਣਾਤਮਕ ਅਨੁਵਾਦ';

        }
        if(baniSubsectionDetailType == 'ਕੈਲੀਗ੍ਰਾਫੀ'){
          baniSubsectionDetailType = 'Calligraphy';
          this.activeSubsectionDetailTitle = 'ਕੈਲੀਗ੍ਰਾਫੀ';
        }
      }

    switch (baniSubsectionDetailType) {
      case BaniSectionProps.OVERVIEW: 
        this.activeSubSectionHTML = this.setFootnotesData(
          this.activeSubSectionData.SubSectionContent
        );
        break;
      case BaniSectionProps.COMMENTARY: 
        this.activeSubSectionHTML = this.setFootnotesData(
          this.activeSubSectionData.SubSectionCommentary
        );
        break;
      case BaniSectionProps.LITERAL_TRANSLATION:
        this.activeSubSectionHTML = this.setFootnotesData(
          this.activeSubSectionData.SubSectionLiteralTranslation
        );
        break;
      case BaniSectionProps.POETIC_DIMENSION:
        this.activeSubSectionHTML = this.setFootnotesData(
          this.activeSubSectionData.SubSectionPoeticalDimension
        );
        break;
      case BaniSectionProps.INTERPRETIVE:
        this.activeSubSectionHTML = this.setFootnotesData(
          this.activeSubSectionData.SubSectionMeaningInterpretive
        );
        break;
      case BaniSectionProps.CALLIGRAPHY:
        //this.activeSubSectionContent = 'Calligraphy';
       //this.activeSubSectionHTML = this.setFootnotesData(
        //  this.activeSubSectionData.CalligraphyImageURL
        //);

        if(this.activeSubSectionData.CalligraphyImageURL != ''){
          this.activeSubSectionHTML = `<img alt='Calligraphy' class='caligraphy-image' src="${this.activeSubSectionData.CalligraphyImageURL}">`;
        }

        break;
    }
    this.subSectionTopContent = this.addCustomSpacesAndBreaksInString(this.activeSubSectionData.SubSectionContent);

    // console.log(this.activeSubSectionData.SubSectionContent);
  } */

  setSubSectionName(sectionSequence: number, subSectionSequence: number): void {
    const sectionData = this.heirarchyCommonData.Sections?.find(
      (sectionData: any) => {
        return sectionData.SectionSequence === sectionSequence;
      }
    );

    this.activeSubSectionData = sectionData.SubSection?.find(
      (subSectionData: any) => {
        return subSectionData.SubSectionSequence === subSectionSequence;
      }
    );
  console.log("this.activeSubSectionData : ", this.activeSubSectionData);
    this.subSectionName = this.activeSubSectionData.SubSectionName;
  }

  setSectionName(sectionSequence: number): void {
    this.activeSectionData = this.heirarchyCommonData?.Sections?.find(
      (subSectionData: any) => {
        return subSectionData.SectionSequence === sectionSequence;
      }
    );
    // sort subsections in increasing order by SubSectionSequence
    this.activeSectionData.SubSection.sort(
      (a: any, b: any) =>
        parseFloat(a.SubSectionSequence) - parseFloat(b.SubSectionSequence)
    );

    this.subSectionLength = this.activeSectionData?.SubSection.length;

    this.sectionBannerImage = this.activeSectionData?.SectionBannerImage;
    // this.metaService.updateTag({ property: 'og:url', content:  location.origin + this.router.url});
    // this.metaService.updateTag({ property: 'og:title', content: this.heirarchyCommonData?.BaniName });
    // this.metaService.updateTag({ property:'og:image', content: this.activeSectionData.SectionBannerImage });
    // this.metaService.updateTag({ property:'og:description', content: this.heirarchyCommonData?.BaniName });
    this.sectionName = this.activeSectionData?.SectionName
      ? this.activeSectionData.SectionName
      : '';
  }

  /**
   * needs documentation and optimization for all previous and next methods
   * TODO: after functional testing approval
   */
  handlePrevious(st: boolean, SignificantTerms: any) {
    window.scrollTo(0, 0);
    if (st) {
      this.bakUrl =
        SignificantTerms == null ? 'MusicalDimension' : 'SignificantTerms';

      //console.log(SignificantTerms);
      this.router.navigate([
        'bani/introduction/',
        this.heirarchyCommonData.BaniId,
        this.bakUrl,
      ]);
    } else {
      if (this.activeSubSectionSequence) {
        let previousSubSectionSequence: number =
          +this.activeSubSectionSequence - 1;

        let previousSubsection = this.activeSectionData?.SubSection?.find(
          (subSectionData: any) => {
            return (
              subSectionData.SubSectionSequence === previousSubSectionSequence
            );
          }
        );
        if (previousSubsection) {
          this.router.navigate([
            'bani/details/',
            this.baniCode,
            this.activeSectionSequence,
            previousSubSectionSequence,
          ]);
        } else {
          // there is no previous sub section
          // check if there is a previous section
          if (this.activeSectionSequence) {
            let previousSectionSequence = +this.activeSectionSequence - 1;
            let previousSection = this.heirarchyCommonData?.Sections?.find(
              (sectionData: any) => {
                return sectionData.SectionSequence === previousSectionSequence;
              }
            );
            // redirect to the last SubSection by SubSectionSequence of that section

            // sort by increasing order of subsectionsequence
            previousSection.SubSection.sort(
              (a: any, b: any) =>
                parseFloat(a.SubSectionSequence) -
                parseFloat(b.SubSectionSequence)
            );

            this.router.navigate([
              'bani/details/',
              this.baniCode,
              previousSectionSequence,
              previousSection?.SubSection[previousSection?.SubSection.length - 1]
                .SubSectionSequence,
            ]);
            //navaigate to introduction
          }
        }
      }
    } //st else end
  }

  doesPreviousExist() {
    if (this.activeSubSectionSequence) {
      let previousSubSectionSequence: number =
        +this.activeSubSectionSequence - 1;

      let previousSubsection = this.activeSectionData?.SubSection?.find(
        (subSectionData: any) => {
          return (
            subSectionData.SubSectionSequence === previousSubSectionSequence
          );
        }
      );
      if (previousSubsection) {
        return true;
      } else {
        if (this.activeSectionSequence) {
          let previousSectionSequence = +this.activeSectionSequence - 1;
          let previousSection = this.heirarchyCommonData?.Sections?.find(
            (sectionData: any) => {
              return sectionData.SectionSequence === previousSectionSequence;
            }
          );
          return previousSection ? true : false;
        }
      }
      // return previousSubsection ? true : false;
      return false;
    } else {
      return false;
    }
  }

  doesNextExist() {
    if (this.activeSubSectionSequence) {
      let nextSubSectionSequence: number = +this.activeSubSectionSequence + 1;

      let nextSubsection = this.activeSectionData?.SubSection?.find(
        (subSectionData: any) => {
          return subSectionData.SubSectionSequence === nextSubSectionSequence;
        }
      );
      if (nextSubsection) {
        return true;
      } else {
        if (this.activeSectionSequence) {
          let nextSectionSequence = +this.activeSectionSequence + 1;
          // SectionSequence
          let nextSection = this.heirarchyCommonData?.Sections?.find(
            (sectionData: any) => {
              return sectionData.SectionSequence === nextSectionSequence;
            }
          );
          return nextSection ? true : false;
        }
      }
      // return nextSubsection ? true : false;
      return false;
    } else {
      return false;
    }
  }

  handleNext() {
    window.scrollTo(0, 0);
    if (this.activeSubSectionSequence) {
      let nextSubSectionSequence: number = +this.activeSubSectionSequence + 1;
      let nextSubsection = this.activeSectionData?.SubSection?.find(
        (subSectionData: any) => {
          return subSectionData.SubSectionSequence === nextSubSectionSequence;
        }
      );
      if (nextSubsection) {
        this.router.navigate([
          'bani/details/',
          this.baniCode,
          this.activeSectionSequence,
          nextSubSectionSequence,
        ]);
      } else {
        // there is no next sub section
        // look if there is next section
        if (this.activeSectionSequence) {
          let nextSectionSequence = +this.activeSectionSequence + 1;
          // SectionSequence
          let nextSection = this.heirarchyCommonData?.Sections?.find(
            (sectionData: any) => {
              return sectionData.SectionSequence === nextSectionSequence;
            }
          );
          if (nextSection) {
            this.router.navigate([
              'bani/details/',
              this.baniCode,
              nextSectionSequence,
              2,
            ]);
          }
        }
      }
    }
  }

  handleSubSectionSelect(newSubSectionSequence: number) {
    this.router.navigate([
      'bani/details',
      this.heirarchyCommonData.BaniCode,
      this.activeSectionData.SectionSequence,
      newSubSectionSequence,
    ]);
  }

  handleSectionSelect(newSectionSequence: number) {
    this.router.navigate([
      'bani/details',
      this.heirarchyCommonData.BaniCode,
      newSectionSequence,
      newSectionSequence === 0 ? 2 : 2,
    ]);
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
    if (status) {
      this.prevButtonText = '';
      this.nextButtonText = '';
    } else {
      this.prevButtonText = 'previous';
      this.nextButtonText = 'next';
    }
  }

  /**
   * where there is a /r, break the line
   * where there is a /n, add space
   * @param HTMLString
   * @returns
   */
  addCustomSpacesAndBreaksInString(HTMLString: string) {
    if (!HTMLString) {
      return '';
    }
    // where there is a /r, break the line
    // where there is a /n, add space
    let subSectionText: SafeHtml = '';
    // Replace \r tags with <br> tags
    let html = HTMLString;

    // console.log(html);

    // Add a space before and after each \n and \r
    //html = html.replace(/\r\n\r/g, '\r');
    //html = html.replace(/ /g, '&nbsp;');
    html = html.replace(/\n/g, ' \n ');
    html = html.replace(/\r/g, ' \r ');

    // Remove any tags, anything between < and >
    // html = html.replace(/<[^>]*>/g, '');
    // add space before and after a tag

    //html = html.replace(/(<[^>]+>)/g, ' $1 ');

    // Replace \r tags with <br> tags
    //html = html.replace(/\r/g, '');

    html = html.replace(/\r/g, '<br>');

    // Replace \n tags with &nbsp;
    //html = html.replace(/\n/g, '&nbsp;');
    html = html.replace(/\n/g, '');

    //console.log(html);

    html = this.utils.convertString(html);
    //console.log(html);
    subSectionText = this.setFootnotesData(html);
    return subSectionText;
  }

  get currentSectionSequence() {
    return Number(this.route.snapshot.paramMap.get('sectionSequence'));
  }

  get currentSubSectionSequence() {
    return Number(this.route.snapshot.paramMap.get('subSectionSequence'));
  }

  showFontList() {
    this.isVisibleShare = false;
    if (this.visible == true) {
      this.visible = false;
    } else {
      this.visible = true;
    }
  }

  showShareList() {
    this.visible = false;
    if (this.isVisibleShare == true) {
      this.isVisibleShare = false;
    } else {
      this.isVisibleShare = true;
    }
  }

  setFont(size: any) {
    this.storage.set('fontSize', size);
    this.fontSize = size;
    this.visible = false;
  }

  navigateToSearch(tag: any) {
    let param: NavigationExtras = {
      queryParams: {
        type: tag.key,
        keyword: tag.value,
        // type:tag.type,
        // keyword:type.tag
      },
    };
    this.router.navigate(['/search'], param);
  }

  navigateToSearchSabadTitle(tag: any) {
    let param: NavigationExtras = {
      queryParams: {
        type: 'SabadTitle',
        keyword: tag,
        // type:tag.type,
        // keyword:type.tag
      },
    };
    this.router.navigate(['/search'], param);
  }

  getBackgroundImageUrl(img: string) {
    if (this.heirarchyCommonData?.ShowSubSection) {
      img = this.activeSubSectionData?.SectionBannerImage;
    }
    // console.log(img);
    //img= typeof img === 'string' ? img.trim() : '';
    img = img?.trim() || '';
    if (img != '') {
      this.txtColor = 'white';
      return `url('${img}')`;
    } else {
      this.txtColor = 'black';
      let imgUrl = '/assets/images/carousel-background.webp';
      return `url(${imgUrl})`;
    }
    return;
  }

  hideTypes(baniSubsectionDetailType: string): boolean {
    if (
      (baniSubsectionDetailType === 'Commentary' ||
        baniSubsectionDetailType === 'ਵਿਆਖਿਆ') &&
      !this.activeSubSectionData.SubSectionCommentary
    ) {
      return false;
    } else if (
      (baniSubsectionDetailType === 'Calligraphy' ||
        baniSubsectionDetailType === 'ਕੈਲੀਗ੍ਰਾਫੀ') &&
      !this.activeSubSectionData.CalligraphyImageURL
    ) {
      return false;
    } else {
      return true;
    }
  }

  fetchLanguage(): string | null {
    return this.storage.get('language');
  }
}
